import { merge } from "lodash";
import addressModuleActions from "./addressModule/actions";
import shipmentModuleActions from "./shipmentModule/actions";
import carrierModuleActions from "./carrierModule/actions";

export default merge(addressModuleActions, shipmentModuleActions, carrierModuleActions);
